import React, { useEffect, useState } from "react";
import {
	Dialog,
	DialogContent,
	DialogTitle,
	LinearProgress,
} from "@mui/material";
import { makeStyles } from "tss-react/mui";
import { useTranslation } from "react-i18next";

import DyanamicDropdown from "components/Elements/DynamicDropdown";
import { getLocalStorageData } from "helpers/utils";
import { useDispatch } from "react-redux";
import { useParams } from "react-router-dom";
import { showError } from "../../../redux/common/actions";
import { getDefectStatuses } from "services/clients/sites/siteApplications/defectStatuses";
import { updateDefect } from "services/defects/details";
import AddDialogStyle from "styles/application/AddDialogStyle";
import { handleSort } from "helpers/utils";

const ADD = AddDialogStyle();

const useStyles = makeStyles()((theme) => ({
	dialogContent: {
		width: 500,
	},
	createButton: {
		width: "auto",
	},
}));

function ChangeStatusPopup({ open, onClose, setDetails, fetchDefect }) {
	const { t } = useTranslation();
	const { classes, cx } = useStyles();
	const [isUpdating, setIsUpdating] = useState(false);
	const [defectStatuses, setDefectStatuses] = useState([]);
	const [selectedStatus, setSelectedStatus] = useState({});
	const dispatch = useDispatch();
	const { id } = useParams();

	const handleConfirmStatusChange = async () => {
		if (selectedStatus?.id === undefined) {
			return;
		}
		setIsUpdating(true);
		const response = await updateDefect(id, [
			{
				op: "replace",
				path: "DefectStatusID",
				value: selectedStatus.id,
			},
		]);
		if (response.status) {
			setDetails((prev) => ({
				...prev,
				defectStatusID: selectedStatus.id,
				defectStatusName: selectedStatus.name,
				defectStatusType: selectedStatus.type,
			}));
			// A manual status change clears SAP error state server-side
			// (EMI3-1394), so refetch instead of mirroring fields locally.
			await fetchDefect?.();
		} else
			dispatch(
				showError(
					response.data?.detail ||
						response?.data ||
						t("validation.couldNotUpdateModelStatus")
				)
			);
		onClose();

		setIsUpdating(false);
	};
	const handleStatusChange = (status) => setSelectedStatus(status);

	const fetchDefectStatuses = async () => {
		const { siteAppID } = getLocalStorageData("me");
		setIsUpdating(true);
		const response = await getDefectStatuses(siteAppID);

		if (response.status) {
			setDefectStatuses(response.data.map((status) => status));
		} else {
			dispatch(showError(t("validation.couldNotFetchStatuses")));
		}

		setIsUpdating(false);
	};

	useEffect(() => {
		if (open) {
			fetchDefectStatuses();
		}

		if (!open) {
			setSelectedStatus({});
		}
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [open]);

	return (
		<Dialog
			open={open}
			onClose={onClose}
			aria-labelledby="alert-dialog-title"
			aria-describedby="alert-dialog-description"
			className="application-dailog"
		>
			{isUpdating ? <LinearProgress /> : null}

			<ADD.ActionContainer>
				<DialogTitle id="alert-dialog-title">
					{<ADD.HeaderText>{t("action.changeStatus")}</ADD.HeaderText>}
				</DialogTitle>
				<ADD.ButtonContainer>
					<div className="modalButton">
						<ADD.CancelButton onClick={onClose} variant="contained">
							{t("action.cancel")}
						</ADD.CancelButton>
					</div>
					<div className="modalButton">
						<ADD.ConfirmButton
							onClick={handleConfirmStatusChange}
							variant="contained"
							className={classes.createButton}
							disabled={isUpdating}
						>
							{t("action.confirm")}
						</ADD.ConfirmButton>
					</div>
				</ADD.ButtonContainer>
			</ADD.ActionContainer>

			<DialogContent className={classes.dialogContent}>
				<DyanamicDropdown
					placeholder={t("placeholder.selectItem")}
					dataSource={defectStatuses}
					onChange={handleStatusChange}
					selectedValue={selectedStatus}
					selectdValueToshow="name"
					columns={[{ name: "name", id: 1 }]}
					dataHeader={[{ name: t("label.name"), id: 1 }]}
					showHeader
					handleSort={handleSort}
				/>
			</DialogContent>
		</Dialog>
	);
}

export default ChangeStatusPopup;
